import { EGoogleRedirectStatus } from 'constants/Google';
import React from 'react';
import StatusDisplayer from './StatusDisplayer';

const Approved = () => {
  return <StatusDisplayer status={EGoogleRedirectStatus.APPROVED} />;
};

export default Approved;
